import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-save-hotspot-template-no-row-toast',
  templateUrl: './save-hotspot-template-no-row-toast.component.html',
  styleUrls: ['./save-hotspot-template-no-row-toast.component.css']
})
export class SaveHotspotTemplateNoRowToastComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
